import React, { useEffect, useState } from 'react';
import './header.scss';
import LOGO_SMALL from '../assets/logo_small.png';
import { useHistory, useLocation, useParams } from 'react-router-dom';

interface IProps {
  className?: string;
}

interface Ilang {
  [key: string]: {
    en: string;
    'zh-cn': string;
  };
}

const Header = (props: IProps) => {
  const history = useHistory();
  const location = useLocation();

  const toHome = () => history.push(`/${lang}`);
  const toAbout = () => history.push(`/${lang}/about`);
  const toContact = () => history.push(`/${lang}/contact`);
  const toProduct = () => history.push(`/${lang}/product`);
  const toNews = () => history.push(`/${lang}/news`);

  const map: Ilang = Object.freeze({
    a: {
      en: 'Home',
      'zh-cn': '首页',
    },
    b: {
      en: 'Product Center',
      'zh-cn': '产品中心',
    },
    c: {
      en: 'News',
      'zh-cn': '新闻资讯',
    },
    d: {
      en: 'About Fantai',
      'zh-cn': '关于钒泰',
    },
    e: {
      en: 'Contact Us',
      'zh-cn': '联系我们',
    },
  });

  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const changeLang = (lang: 'en' | 'zh-cn') => {
    console.log(location.pathname);
    const pathname = location.pathname.replace(/\/(en|zh-cn)/g, '/' + lang);
    console.log(pathname);
    history.push(pathname);
  };

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === '/') {
      history.push('/zh-cn');
    }
  }, []);

  return (
    <div className={`header-content ${props.className || ''}`}>
      <div className='lang-group'>
        <div className={`lang-cn lang ${lang === 'zh-cn' ? 'active' : ''}`} onClick={() => changeLang('zh-cn')}>
          中文版
        </div>
        <div className={`lang-en lang  ${lang === 'en' ? 'active' : ''}`} onClick={() => changeLang('en')}>
          English
        </div>
      </div>
      <div className='logo-container' onClick={toHome}>
        <img src={LOGO_SMALL} alt='钒泰精化' />
      </div>
      <ul className='menu'>
        <li className={`sub-menu ${location.pathname.match(/^\/(en|zh-cn)?$/) ? 'active' : ''}`} onClick={toHome}>
          {map.a[la]}
        </li>
        <li className={`sub-menu ${location.pathname.includes('/product') ? 'active' : ''}`} onClick={toProduct}>
          {map.b[la]}
        </li>
        <li className={`sub-menu ${location.pathname.includes('/news') ? 'active' : ''}`} onClick={toNews}>
          {map.c[la]}
        </li>
        <li className={`sub-menu ${location.pathname.includes('/about') ? 'active' : ''}`} onClick={toAbout}>
          {map.d[la]}
        </li>
        <li className={`sub-menu ${location.pathname.includes('/contact') ? 'active' : ''}`} onClick={toContact}>
          {map.e[la]}
        </li>
      </ul>
    </div>
  );
};

export default Header;
